import isInstance from './isInstance.js';

const isObject = (x) => isInstance(Object, x);
export default isObject;
